import { toegangClientSecret } from '@thiememeulenhoff/nx-sdk';
import { Environment } from '@thiememeulenhoff/types';
import { deployUrl } from '../features/admin/utils/deploy-url';
import { EnvironmentType } from './environment.type';

export const environment: EnvironmentType = {
  environment: Environment.Test,
  production: true,
  localParsingEnabled: false,
  deployUrl: deployUrl(),
  datadog: {
    applicationId: '487624e5-b6b5-40f9-b0bb-d774a9902053',
    clientToken: 'pub4b3d1aaff88846caa4b1b81468f30005',
    env: Environment.Test,
    sessionSampleRate: 5,
    sessionReplaySampleRate: 0,
  },
  unleash: {
    instance: 'eu.app.unleash-hosted.com/euee0007',
    clientKey:
      '*:development.9fcfa139893173c16ee5fae24b057c205de41bf1da110a43f428a340',
    environment: 'development',
    refreshInterval: 5 * 60, // 5 minutes
    metricsInterval: 15 * 60, // 15 minutes
  },
  analytics: {
    tagManagerId: 'GTM-P4XBW2XB',
    tagManagerAuth: 'GeaP1YTxQ7HUkz0nVUWsqw',
    tagManagerPreview: 'env-2',
  },
  thas: {
    environment: 'test',
    token: '1fd08813ca7db624db5cc864a0588f98d86da2cbefa2f7ec59bd3e95e304b1bc',
  },
  auth: {
    environment: Environment.Test,
    clientId: 'edu-admin',
    clientSecret: toegangClientSecret('EDU_ADMIN'),
    useUserCookie: false,
  },
  tham: {
    proxyDomain: 'https://d1s17n93wzfusy.cloudfront.net',
  },
  thiemo: 'https://thiemo.thiememeulenhoff.nl/secure',
  mboDocent: 'https://mbodocent.thiememeulenhoff.nl/secure',
  cockpit: 'https://cockpit.thiememeulenhoff.nl',
  edition: 'https://test.edition.thiememeulenhoff.nl',
  myTM: 'https://acc.mijn.thiememeulenhoff.nl',
  mockData: false,
  groupServices: {
    demoGroupId: '1329508',
    demoGroupCode: 'W5Z5',
  },
  wilmaEndpoint: 'https://test.wilma.thiememeulenhoff.nl',
};
